import './RentAcademyPage.css'; 
import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
// import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Import Bootstrap JS
import Tab from "bootstrap/js/dist/tab";  
import AOS from 'aos';
import 'aos/dist/aos.css';
import RentApply from './RentApply/Index';
import AIheader from '../../../pages/RentAI/AIheader';
const RentAcademyPage = ()=>{


    // START TAB
    useEffect(() => {
        AOS.init({
            duration: 1000,
            offset: 100,
            delay: 500,
            easing: 'ease-in-sine',
            anchorPlacement: 'top-bottom',
        once: false,  
        });

        const handleTabShown = () => {
            setTimeout(() => {
            AOS.refresh(); 
            }, 100);
        };
    
        const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');
        tabs.forEach((tab) => {
            tab.addEventListener('shown.bs.tab', handleTabShown);
        });
    
        return () => {
            tabs.forEach((tab) => {
            tab.removeEventListener('shown.bs.tab', handleTabShown);
            });
        };
        
    }, []);
    // END TAB

    // START welcomeAcademyMain //
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };
    // END welcomeAcademyMain //

    // START nationalEventsAcademyMain //
    const tabs = ["tabNational_1", "tabNational_2", "tabNational_3", "tabNational_4"]; // Array of tab IDs
    const [currentTabIndex, setCurrentTabIndex] = useState(0); // Current tab index

    useEffect(() => {
      const interval = setInterval(() => {
        const nextTabIndex = (currentTabIndex + 1) % tabs.length; 
        const nextTabId = tabs[nextTabIndex];

        const nextTab = new Tab(document.getElementById(nextTabId));
        nextTab.show();
        setCurrentTabIndex(nextTabIndex); 
      }, 10000); // Switch every 5 seconds
  
      return () => clearInterval(interval); 
    }, [currentTabIndex]); 
    // END nationalEventsAcademyMain //


    return(
        <>
            <AIheader/>
        <div className="rd-legacy">


            {/* START bannerInnerMain */}
            <section className="bannerInnerMain bannerAcademyMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="bannerPageInner">
                                <figure><img src="/logos/products/rentacademy-white.png" alt="Rental management training"/></figure>
                                <h1>Rental management training, education, and updates.</h1>
                                <p>Stay ahead with expert training, industry insights, and the latest updates to optimize your rental business.</p>
                                {/* <div className="bannerBtn">
                                    <a href="#" className="btn">
                                    <span>Watch Video</span>
                                    <img width="16px" src="/img/video_play.svg" alt="Watch Video"/>
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerInnerMain */}


            {/* START academyRentalsMain */}
            <section className='academyRentalsMain'>
                <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                    <div className='academyRentalsLeft'>
                        <h6>MASTER THE ART OF VEHICLE RENTAL</h6>
                        <h2>Learn on your own time, not  your dime.</h2>
                        <p>Access exclusive content created by industry leaders and disruptors, expertly designed to provide real-world value, actionable insights, and the latest trends. </p>
                        <ul>
                            <li>
                                <a href="#welcomeAcademyMain">
                                    <img width="24px" height="24px"src="/img/rentacademy/rent_academy_icon.svg" alt="commercial_icon" />
                                    Rent Academy
                                </a>
                            </li>
                            <li>
                                <a href="#nationalEventsAcademyMain">
                                    <img width="24px" height="24px"src="/img/rentacademy/national_events_icon.svg" alt="car-shield" />
                                    National Events
                                </a>
                            </li>

                            <li>
                                <a href="#BehindWheel">
                                    <img width="24px" height="24px"src="/img/rentacademy/behind_wheel_icon.svg" alt="user" />
                                    Behind the Wheel
                                </a>
                            </li>

                            <li>
                                <a href="#video-library">
                                    <img width="24px" height="24px"src="/img/rentacademy/video_library _icon.svg" alt="tow truck" />
                                    Video Library
                                </a>
                            </li>
                            <li>
                                <a href="#TrainingSupport">
                                    <img width="24px" height="24px"src="/img/rentacademy/app_resources_icon.svg" alt="web protection" />
                                    In App Resources
                                </a>
                            </li>
                            <li>
                                <a href="#affiliatePartnerMain">
                                    <img width="24px" height="24px"src="/img/rentacademy/affiliate_program_icon.svg" alt="digital" />
                                    Affiliate Program
                                </a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <div className='academyRentalsRight'>
                            <img className="img-fluid" src="/img/rentacademy/academyRentalsRight.webp" alt="academy Rentals" />
                        </div>
                    </div>
                </div>
                </div>
            </section>
            {/* END academyRentalsMain */}

            {/* START welcomeAcademyMain */}
            <section className='welcomeAcademyMain' id='welcomeAcademyMain'>
                <img className="welcomeAcademy_1" src="/img/rentacademy/welcomeAcademy_1.svg" alt="Welcome to Rent Academy"/>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                            <div className='welcomeAcademyInner'>
                                <h2>Welcome to Rent Academy</h2>

                                <p className={isExpanded ? "expanded" : "collapsed"}>
                                    <span className='welcomeAcademySpace'>This Academy is a space built to give back to the community of vehicle rental operators 
                                    and entrepreneurs. Our mission is to share the collective knowledge and insights we’ve 
                                    gathered from decades of experience, industry leaders, and innovators who are reshaping 
                                    mobility  <br/>{!isExpanded && <span id="dots">...</span>} 
                                    </span>
                                    
                                    {isExpanded && (
                                        <>
                                      
                                        <span className='welcomeAcademySpace'>Through this platform, we aim to equip you with practical tools and 
                                        actionable knowledge to help you succeed. Whether you're new to the industry or a seasoned 
                                        operator, our goal is to support your journey by providing access to trusted expertise, 
                                        proven strategies, and a space to grow your business. </span>
                                        
                                        <span className='welcomeAcademySpace'>We believe that progress happens 
                                        through collaboration and shared experiences. That’s why this Academy is dedicated to 
                                        fostering a community where ideas flow freely, solutions are built together, and everyone 
                                        benefits. By leveraging the voices and expertise of those shaping the industry, we’re 
                                        helping you and your business thrive in a rapidly evolving space. Step into the Academy 
                                        and let’s grow together—one connection, one lesson, and one success at a time.
                                        </span>

                                        </>
                                    )}
                                </p>
                                <div className="welcomeBtn">
                                    <button onClick={toggleExpand} className={`btn ${isExpanded ? "expanded" : "collapsed"}`}>
                                    {isExpanded ? "Read Less" : "Read More"}
                                        <img width="24px" height="24px"
                                            src="/img/rentacademy/arrow-down.svg" alt="arrow"
                                            style={{ transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }}
                                        />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END welcomeAcademyMain */}
 
            {/* START nationalEventsAcademyMain */}
            <section className="nationalEventsAcademyMain" id='nationalEventsAcademyMain'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="headNationalEventsAcademy">
                                <h2>Meet Rentid at National Events</h2>
                                <p>Great ideas start with meaningful conversations. Connect with us at 
                                events to shape the future of car rental — together.</p>
                            </div>
                        </div>
                    </div>
                    <div className='nationalEventsAcademyOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="tabNational_1" data-bs-toggle="tab" href="#nationalEventsAcademy_1">
                                            <h3>Exclusive Insights and Educational Sessions:</h3>
                                            <p>Learn from industry experts in panels, workshops, and discussions covering the latest trends 
                                            and strategies in car rentals and mobility.</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="tabNational_2" data-bs-toggle="tab" href="#nationalEventsAcademy_2">
                                            <h3>Hands-On Experience with Rentid:</h3>
                                            <p>Explore live demos of our innovative products and gain an insider look at how 
                                            Rentid can transform your business.</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="tabNational_3" data-bs-toggle="tab" href="#nationalEventsAcademy_3">
                                            <h3>Networking Opportunities and Team Connections:</h3>
                                            <p>Build valuable relationships with industry leaders, peers, and the Rentid team. Engage in 
                                            one-on-one conversations to ask questions, share ideas, and explore partnership opportunities.</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="tabNational_4" data-bs-toggle="tab" href="#nationalEventsAcademy_4">
                                            <h3>Event-Only Offers and Future Previews:</h3>
                                            <p>Take advantage of exclusive promotions and get an early look at upcoming features and 
                                            initiatives that could drive your success.</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                <div className="tab-content">
                                    {/* START Tab 1 */}
                                    <div className="tab-pane active" id="nationalEventsAcademy_1">
                                        <div className='nationalEventsAcademyRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                                <img src="/img/rentacademy/nationalEventsAcademy_1.webp" alt="Rentid at National Events"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 1 */}

                                    {/* START Tab 2 */}
                                    <div className="tab-pane fade" id="nationalEventsAcademy_2">
                                        <div className='nationalEventsAcademyRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                                <img  src="/img/rentacademy/nationalEventsAcademy_2.webp" alt="Rentid at National Events"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 2 */}

                                    {/* START Tab 3 */}
                                    <div className="tab-pane fade" id="nationalEventsAcademy_3">
                                        <div className='nationalEventsAcademyRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                                <img src="/img/rentacademy/nationalEventsAcademy_3.webp" alt="Rentid at National Events"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 3 */}

                                    {/* START Tab 4 */}
                                    <div className="tab-pane fade" id="nationalEventsAcademy_4">
                                        <div className='nationalEventsAcademyRight' data-aos="fade-in" data-aos-delay="200">
                                            <figure>
                                                <img src="/img/rentacademy/nationalEventsAcademy_4.webp" alt="Rentid at National Events"/>
                                            </figure>
                                        </div>
                                    </div>
                                    {/* END Tab 4 */}



                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="nationalEventsAcademyBottom">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <img className="img-fluid" src="/img/power_rent_academy.svg" alt="icon"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END nationalEventsAcademyMain */}

            {/* START wheelPodcastMain 
            <section className="wheelPodcastMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="headWheelPodcast">
                                <h2>Behind the Wheel <span>Podcast</span></h2>
                                <p>A modern voice for modern rental is arriving. The Rentid Podcast will bring you conversations 
                                    designed to inform, inspire, and elevate your business. Stay tuned for updates as we prepare 
                                    to launch a platform built to share ideas and explore the future of mobility.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='wheelPodcastOuter'>
                    <div className="container">
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-lg-8 col-md-12 col-sm-12 col-12'>
                                <div className='wheelPodcastInner'>
                                    <h3><span>Tips</span> from the <span>best, #getrentid</span> and <span>grow</span>.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
           END wheelPodcastMain */}

            {/* START wheelPodcastMain */}
            <section className="wheelPodcastMain1" id="BehindWheel">
                <img  src="/img/rentacademy/podcast_bg_2.webp" alt="rent id"/>

            </section>
            {/* END wheelPodcastMain */}

            {/* START contentCreatorsMain */}
            <section className="contentCreatorsMain" id='contentcreator'>
                <div className="container">
                    <div className="contentCreatorsInner">   
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='contentCreatorsLeft'>
                                    <h2>Open call for content creators</h2>
                                    <p>We’re looking for passionate operators, 
                                    innovators, and industry professionals to share their stories, insights, and 
                                    expertise on the Rentid Podcast. Ready to inspire and engage - we want to 
                                    hear from you!</p>
                                    <a className="btn btnGradient_2" href='/apply-academy'>Apply Now</a>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='contentCreatorsRight'>
                                    <figure>
                                        <img src="/img/rentacademy/contentCreators_1.webp" alt="Open call for content creators"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END contentCreatorsMain */}

            {/* START videoLibraryMain */}
            <section className="videoLibraryMain" id='video-library'>
                <div className="container">
                    <div className="videoLibraryInner">   
                        <div className='row align-items-end'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='videoLibraryLeft'>
                                    <h2 data-aos="fade-up" data-aos-delay="100">Explore the <span>Video Library</span></h2>
                                    <p data-aos="fade-up" data-aos-delay="200">Unlock growth with our 24/7 video library—platform 
                                    tutorials, expert insights, success stories, and strategies to help you thrive in the rental 
                                    industry anytime, anywhere.</p>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='videoLibraryRight'>
                                    <figure>
                                        <img data-aos="zoom-out" data-aos-delay="300" src="/img/rentacademy/videoLibrary_1.webp" alt="Video Library"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END videoLibraryMain */}

        {/* START trainingSupportMain */}
        <section className="trainingSupportMain" id="TrainingSupport">
            <div className="container">
                <div className='trainingSupportOuter'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                            <div className='trainingSupportLeft'>
                                <figure>
                                    <img  src="/img/rentacademy/trainingSupport.webp" alt="Training and support" />
                                </figure>
                            </div>
                        </div>
                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                            <div className='trainingSupportRight'>
                                <h2>Training and support on the go. All in <span> 
                                    the Rentid App.</span></h2>
                                <p>Whether you're starting with Rentid, managing vehicle rentals, or training 
                                your team, our exclusive in-app learning hub is built for growth on your schedule. 
                                Access industry insights, master new skills, and stay ahead—anytime, anywhere.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* END trainingSupportMain */}

        {/* START affiliatePartnerMain */}
        <section className="affiliatePartnerMain" id="affiliatePartnerMain">
            <div className="container"> 
                <div className='row justify-content-center align-items-center'>
                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className='affiliatePartnerInner'>
                            <h2>Become an Affiliate Partner <span>Empower your Audience</span></h2>
                            <p>Join Rentid's affiliate program and help revolutionize 
                            the car rental experience. We're looking for influencers, creators, and partners who share 
                            our passion for innovation and growth. Submit your details, and let’s explore how we can 
                            drive success together.</p>
                            <a className="btn btnBlue" href="/apply-affilates">Apply Now</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
        {/* END affiliatePartnerMain */}
        
        <RentApply/>
        </div>
        </>
    )
}

export default RentAcademyPage;